import { IControllerType } from '@/redux/post/post.d';
import { CONTROLLER_CONFIG } from '@/lib/controllerConfig';

export const inferGroupName = (fileName: string): string => {
  const withoutExt = fileName.replace(/\.[^/.]+$/, '');
  const tokens: string[] = [
    ...Object.values(IControllerType),
    ...Object.values(CONTROLLER_CONFIG).map((c) => c.name),
  ]
    .filter(Boolean)
    .map((t) => String(t));
  const pattern = new RegExp(`^(${tokens.join('|')})_`, 'i');
  const stripped = withoutExt.replace(pattern, '');
  return stripped.trim();
};

export default inferGroupName;
